export default "__VITE_ASSET__j$5ghWDv__"